export default __webpack_public_path__ + "static/media/Accessibility.cf238d99.pdf";